/* eslint-disable no-unused-vars */
import { Spin } from 'antd';
import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
// import DashboardRoutes from './dashboard';
import { Dashboard, ECards, EmpTrainings, NumberSeries, Signatures, Designations } from '../../pages/super-admin';
import Companies from '../../pages/super-admin/companies';
import CompanyFPs from '../../pages/super-admin/company-focal-persons';
import TrainingCenters from '../../pages/super-admin/training-centers';
import TrainingCources from '../../pages/super-admin/training-courses';
import Users from '../../pages/super-admin/users';
import CompanyAddresses from '../../pages/super-admin/company-addresses';
import CompanyAttachments from '../../pages/super-admin/company-attachments';
import CardsValidity from '../../pages/super-admin/cards-validity';
import { Employees, NotificationsCenter } from '../../pages/common';
import withAdminLayout from '../../layout/withAdminLayout';

const NotFound = lazy(() => import('../../container/pages/404'));

const SuperAdmin = React.memo(() => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        {/* <Route index path="/*" element={<DashboardRoutes />} /> */}
        <Route index path="/dashboard" element={<Dashboard />} />
        <Route index path="/companies" element={<Companies />} />
        <Route index path="/comp-fps" element={<CompanyFPs />} />
        <Route index path="/comp-addresses" element={<CompanyAddresses />} />
        <Route index path="/emps" element={<Employees />} />
        <Route index path="/designations" element={<Designations />} />
        <Route index path="/comp-atts" element={<CompanyAttachments />} />
        <Route index path="/t-centers" element={<TrainingCenters />} />
        <Route index path="/t-courses" element={<TrainingCources />} />
        <Route index path="/users" element={<Users />} />
        <Route index path="/emp-trainings" element={<EmpTrainings />} />
        <Route index path="/e-cards" element={<ECards />} />
        <Route index path="/notifications" element={<NotificationsCenter />} />
        <Route index path="/c-validity" element={<CardsValidity />} />
        <Route index path="/n-series" element={<NumberSeries />} />
        <Route index path="/signatures" element={<Signatures />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(SuperAdmin);
